import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Global } from '../../global.constants';
import { Utility } from '../../utility';
import { DBkeys } from '../auth/db-keys';
import { DisplayNotificationService } from '../common/notification.service';
import { ReadConfigService } from '../common/read-config.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private http: HttpClient,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }
  readonly rootUrl = this.readConfigService.getApiUrl();
  apiTimeout = this.readConfigService.getApiTimeout();
  reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
  reqNoAuthHeader = new HttpHeaders({ 'No-Auth': 'True' });
  reqOctHeader = new HttpHeaders({ 'Content-Type': 'application/octet-stream' });
  uploadedFile: any;
  errorMessage = this.readConfigService.getDocumentErrorMessage();
  errorSize = this.readConfigService.getDocumentMinSize();

  UserInfo(): any {
    const userInfo = {
      encryptOrg: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_ORGID)),
      encryptUsr: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_USER))
    };
    return userInfo;
  }

  saveFileUpload(file: any) {
    this.uploadedFile = file;
  }

  getFileUpload() {
    return this.uploadedFile;
  }

  uploadMemberDocBatch(userInfo: any, files: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('userInfo', userInfo);
    files.forEach((element: any) => {
      formData.append('uploadFile', element.rawFile);
    });
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    const url = this.rootUrl + Global.BASE_UPLOAD_MEMBER_DOC_BATCH_ENDPOINT;
    return this.http.post<any>(url, formData, { headers })
      .pipe(this.handleError());
  }

  getMdsDocTypes(): Observable<any> {
    const url = this.rootUrl;
    //   + Global.BASE_GET_MDS_DOC_TYPE_ENDPOINT;
    return this.http.post<any>(url, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getMyDocuments(): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    const url = this.rootUrl + Global.BASE_GET_DOCUMENTS_ENDPOINT;
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getMemDocHistory(): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo };
    const url = this.rootUrl + Global.BASE_GET_MEM_DOC_HISTORY_ENDPOINT;
    return this.http.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getMyDocument(dataId: any, fileName: any): Observable<any> {
    const userInfo = this.UserInfo();
    const obj = { userInfo, UniqueId: dataId };
    const url = this.rootUrl + Global.BASE_GET_DOCUMENT_ENDPOINT;
    return this.http.post<any>(url, obj, { headers: this.reqHeader, responseType: 'blob' as 'json' })
      .pipe(this.handleErrorWithDocSize(fileName));
  }

  viewAdjFile(data: any, fileName: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_VIEW_ADJ_FILE_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader, responseType: 'blob' as 'json' })
      .pipe(this.handleErrorWithDocSize(fileName));
  }

  viewInvoice(data: any, fileName: string): Observable<any> {
    fileName = fileName + '.pdf';
    const url = this.rootUrl + Global.BASE_CREATE_INVOICE_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader, responseType: 'blob' as 'json' })
      .pipe(this.handleErrorWithDocSize(fileName));
  }

  viewPaidInvoice(data: any): Observable<any> {
    const url = this.rootUrl + Global.BASE_VIEW_PAID_INVOICE_ENDPOINT;
    return this.http.post<any>(url, data, { headers: this.reqHeader, responseType: 'blob' as 'json' })
      .pipe(this.handleErrorWithDocSize(data.fileName));
  }

  downloadFile(response: any, filename: string): string {
    const blob = new Blob([response]);
    const url = window.URL.createObjectURL(blob); // <-- work with blob directly
    // IE & Edge
    const nav = (window.navigator as any);
    if (nav && nav.msSaveOrOpenBlob) {
      // msSaveBlob only available for IE & Edge
      nav.msSaveOrOpenBlob(blob, filename);
    } else {
      // create hidden dom element (so it works in all browsers)
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(url);
      }, 100);
    }
    return url;
  }

  handleError() {
    return timeout(this.apiTimeout),
      catchError((err: any) => {
        return throwError(err || 'Server error');
      }),
      map((v: any) => {
        if (v) {
          return v;
        }
      });
  }

  handleErrorWithDocSize(fileName: string) {
    return timeout(this.apiTimeout),
      catchError((err: any) => {
        return throwError(err || 'Server error');
      }),
      map((res: any) => {
        if (res && res.size > this.errorSize) {
          this.downloadFile(res, fileName);
        } else {
          this.notificationService.setErrorNotification(this.errorMessage);
        }
      });
  }
}
